// Sidebar entries owned by the Customer module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { SidebarType } from '@/types/shared'
import { resources, scopes } from '@/utils/permission'
import { customerPaths } from './paths'

export const customerNav = {
    list: {
        title: 'customer:sidebar_list',
        path: customerPaths.customersList,
        rsname: resources.customers,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
} satisfies Record<string, SidebarType>
